module.exports = __webpack_public_path__ + "img/img5.9ed5c940.jpg";